import { Component } from '@angular/core';

@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['../../../assets/css/footer-pages.css'],
})
export class TerminosCondicionesComponent {}
